import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/blog/[id]/page.tsx");
